
define('inlineSvg!svgs/icon/tick', function () {return '<span class="inline-tick inline-icon"><svg width="10.79" height="8.608" viewBox="0 0 10.79 8.608"><path d="M2.987 6.575L10.244 0l.546.532-7.803 8.076h-.26L0 4.788l.545-.546 2.442 2.333z"/></svg></span>';});

